export function getIconHtml(iconName, iconLibrary) {
  const iconMapping = {
    calendar: {
      fa: "fas fa-calendar",
      "material-icons": {
        class: "material-icons",
        name: "calendar_today",
      },
    },
    call: {
      fa: "fas fa-phone fa-flip-horizontal",
      "material-icons": {
        class: "material-icons",
        name: "call",
      },
    },
    callOutline: {
      fa: "fas fa-phone fa-flip-horizontal",
      "material-icons": {
        class: "material-icons material-icons-outlined",
        name: "call",
      },
    },
    direction: {
      fa: "fas fa-map-marker-alt",
      "material-icons": {
        class: "material-icons",
        name: "directions",
      },
    },
    layers: {
      fa: "fas fa-layer-group",
      "material-icons": {
        class: "material-icons",
        name: "layers",
      },
    },
    mapMarker: {
      fa: "fas fa-map-pin",
      "material-icons": {
        class: "material-icons",
        name: "location_on",
      },
    },
    mapMarkerOutline: {
      fa: "fas fa-map-pin",
      "material-icons": {
        class: "material-icons material-icons-outlined",
        name: "location_on",
      },
    },
    time: {
      fa: "far fa-clock",
      "material-icons": {
        class: "material-icons",
        name: "access_time",
      },
    },
    warning: {
      fa: "fas fa-exclamation-triangle",
      "material-icons": {
        class: "material-icons",
        name: "warning",
      },
    },
  };
  if (iconLibrary == "material-icons") {
    return `
      <span data-nosnippet
        class="${iconMapping[iconName]["material-icons"].class}"
        role="presentation"
        aria-hidden="true"
      >
        ${iconMapping[iconName]["material-icons"].name}
      </span>
    `;
  }
  return `<i class="${iconMapping[iconName].fa}" aria-hidden="true"></i>`;
}
